import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import PhoneGate from "./components/PhoneGate";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import CourierSchedule from "./pages/CourierSchedule";
import ResetPassword from "./pages/ResetPassword";
import InstallApp from "./pages/InstallApp";
import { Privacy, Terms, Cookies } from "./pages/Legal";
import CookieBanner from "./components/CookieBanner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Courier page: full-screen layout, no header/footer/cart
  if (location.pathname.startsWith("/courier/")) {
    return (
      <Routes>
        <Route path="/courier/:date" element={<CourierSchedule />} />
      </Routes>
    );
  }
  return (
    <>
      <Header />
      <CartDrawer />
      <PhoneGate />
      <CookieBanner />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/installa" element={<InstallApp />} />
          <Route path="/install" element={<InstallApp />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Terms />} />
          <Route path="/cookie-policy" element={<Cookies />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
